import type { ApiFetchCategoryGamesPort } from '~/handlers/ports/api-fetch-category-games.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchCategoryGamesAdapter
  implements ApiFetchCategoryGamesPort
{
  async handle(slug: string): Promise<HomeCategoryData | null> {
    const response = await fetch(
      `${getApostatudoApiUrl()}/games/categories/${slug}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    // 404 também é a resposta pra categoria existente porém sem jogos
    // vinculados (CategoryController::show) — a seção simplesmente não entra.
    if (!response.ok) return null;

    const json: { success?: boolean; data?: HomeCategoryData } =
      await response.json();

    if (!json?.data?.slug) return null;

    return json.data;
  }
}
